export default __webpack_public_path__ + "static/media/carousel_1.b93ad671.jpg";